//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppConfig from '@/config/app'

// 是否是H5渠道
let h5 = false

// 判断是否到了元旦
let isYuandan = false
const now = Date.now()
const yuandan = new Date(2018, 0, 1).getTime()
if (now > yuandan) {
  isYuandan = true
}

export default {
  name: 'm-product-header',
  data () {
    return {
      h5: h5,
      inActivity: false,
      activityId: '151019418799579',
      isYuandan: isYuandan
    }
  },
  created () {
    // 判断活动是否可用
    this.$http('/api/activityNoLogin/getActivityStatus?activityCode=' + this.activityId).then(response => {
      if (response.data.resultCode === 'error') {
        this.inActivity = false
      } else {
        this.inActivity = true
      }
    })
  },
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
  },
  computed: {
    banner () {
      if (this.h5 && !this.$store.state.h5.configuration.isNull && this.$store.state.h5.configuration.homeBanner) return this.$store.state.h5.configuration.homeBanner
      return AppConfig.images.root + AppConfig.images.banner + '?productCode=' + this.$store.state.order.productId + '&innerCode=' + this.$store.state.order.userId + '&utm_source=' + (this.$route.query.utm_source || '')
    },
    isWKB () {
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) === -1) {
        return false
      }
      return true
    },
    activityURL () {
      return window.location.protocol + '//' + window.location.hostname + '/anniversaries/2018/jixiangsanbao'
    },
    wkbLogo () {
      if (this.h5 && this.homeLogoDisplay && this.$store.state.h5.configuration.homeLogoWkb) {
        return this.$store.state.h5.configuration.homeLogoWkb
      }
      return AppConfig.images.root + AppConfig.images.wkbLogo
    },
    partnerLogo () {
      if (this.h5 && this.homeLogoDisplay && this.$store.state.h5.configuration.homeLogoHengqin) {
        return this.$store.state.h5.configuration.homeLogoHengqin
      }
      return AppConfig.images.root + AppConfig.images.partnerLogo
    },
    homeLogoDisplay () {
      if (this.$store.state.h5.configuration.homeLogoDisplay === 0 && this.h5) {
        return false
      }
      return true
    },
    hidePartnerLogo () {
      if (this.$store.state.h5.configuration.homeLogoDisplay === 2 && this.h5) {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductHeader.vue